import { theme } from 'antd';

export const antFocusTheme = {
	algorithm: [theme.darkAlgorithm],
	token: {
		// Border radius of base components	number	6
		borderRadius: 0,
		// Used to derive the base variable of the background color gradient. In v5, we added a layer of background color derivation algorithm to produce map token of background color. But PLEASE DO NOT USE this Seed Token directly in the code!	string	#fff
		colorBgBase: '#080814',
		// Used to represent the visual elements of the operation failure, such as the error Button, error Result component, etc.	string	#ff4d4f
		colorError: 'rgb(235, 62, 69)',
		// Used to represent the operation information of the Token sequence, such as Alert, Tag, Progress, and other components use these map tokens.	string	#1677ff
		colorInfo: '#f05e39',
		// Control the color of hyperlink.	string	#1677ff
		colorLink: '#f05e39',
		// Brand color is one of the most direct visual elements to reflect the characteristics and communication of the product. After you have selected the brand color, we will automatically generate a complete color palette and assign it effective design semantics.	string	#1677ff
		colorPrimary: '#f05e39',
		// Used to represent the token sequence of operation success, such as Result, Progress and other components will use these map tokens.	string	#52c41a
		colorSuccess: '#f05e39',
		// Used to derive the base variable of the text color gradient. In v5, we added a layer of text color derivation algorithm to produce gradient variables of text color gradient. But please do not use this Seed Token directly in the code!	string	#000
		colorTextBase: 'white',
		// Used to represent the warning map token, such as Notification, Alert, etc. Alert or Control component(like Input) will use these map tokens.	string	#faad14
		colorWarning: 'rgb(235, 62, 69)',
		// The height of the basic controls such as buttons and input boxes in Ant Design	number	32
		controlHeight: 32,
		// The font family of Ant Design prioritizes the default interface font of the system, and provides a set of alternative font libraries that are suitable for screen display to maintain the readability and readability of the font under different platforms and browsers, reflecting the friendly, stable and professional characteristics.	string	-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'
		fontFamily: "'Roboto', Helvetica, Arial, Lucida, sans-serif",
		// Code font, used for code, pre and kbd elements in Typography	string	'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace
		// fontFamilyCode : "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
		// The most widely used font size in the design system, from which the text gradient will be derived.	number	14
		fontSize: 16,
		// Border style of base components	string	solid
		lineType: 'solid',
		// Border width of base components	number	1
		lineWidth: 2,
		// Used to configure the motion effect, when it is `false`, the motion is turned off	boolean	true
		// motion : true,
		// number	0
		// motionBase : 0,
		// Preset motion curve.	string	cubic-bezier(0.71, -0.46, 0.88, 0.6)
		// motionEaseInBack : "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
		// Preset motion curve.	string	cubic-bezier(0.645, 0.045, 0.355, 1)
		// motionEaseInOut : "cubic-bezier(0.645, 0.045, 0.355, 1)",
		// Preset motion curve.	string	cubic-bezier(0.78, 0.14, 0.15, 0.86)
		// motionEaseInOutCirc : "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
		// Preset motion curve.	string	cubic-bezier(0.755, 0.05, 0.855, 0.06)
		// motionEaseInQuint : "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
		// Preset motion curve.	string	cubic-bezier(0.215, 0.61, 0.355, 1)
		// motionEaseOut : "cubic-bezier(0.215, 0.61, 0.355, 1)",
		// Preset motion curve.	string	cubic-bezier(0.12, 0.4, 0.29, 1.46)
		// motionEaseOutBack : "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
		// Preset motion curve.	string	cubic-bezier(0.08, 0.82, 0.17, 1)
		// motionEaseOutCirc : "cubic-bezier(0.08, 0.82, 0.17, 1)",
		// Preset motion curve.	string	cubic-bezier(0.23, 1, 0.32, 1)
		// motionEaseOutQuint : "cubic-bezier(0.23, 1, 0.32, 1)",
		// The unit of animation duration change	number	0.1
		// motionUnit : 0.1,
		// number	1
		// opacityImage : 1,
		// The size of the component arrow	number	16
		// sizePopupArrow : 16,
		// The base step of size change, the size step combined with the size change unit, can derive various size steps. By adjusting the step, you can get different layout modes, such as the size step of the compact mode of V5 is 2	number	4
		// sizeStep : 4,
		// The unit of size change, in Ant Design, our base unit is 4, which is more fine-grained control of the size step	number	4
		// sizeUnit : 4,
		// Used to change the visual effect of the component to wireframe, if you need to use the V4 effect, you need to enable the configuration item	boolean	false
		// wireframe : false,
		// The base Z axis value of all components, which can be used to control the level of some floating components based on the Z axis value, such as BackTop, Affix, etc.	number	0
		// zIndexBase : 0,
		// Base zIndex of component like FloatButton, Affix which can be cover by large popup	number	1000
		// zIndexPopupBase: 1000

		// Map Token
		// LG size border radius, used in some large border radius components, such as Card, Modal and other components.	number
		// borderRadiusLG:8,
		// Outer border radius	number
		// borderRadiusOuter:4,
		// SM size border radius, used in small size components, such as Button, Input, Select and other input components in small size	number
		// borderRadiusSM:4,
		// XS size border radius, used in some small border radius components, such as Segmented, Arrow and other components with small border radius.	number
		// borderRadiusXS:2,
		// Control the background color of frosted glass container, usually transparent.	string
		colorBgBlur: 'transparent',
		// Container background color, e.g: default button, input box, etc. Be sure not to confuse this with `colorBgElevated`.	string
		colorBgContainer: '#080814',
		// Container background color of the popup layer, in dark mode the color value of this token will be a little brighter than `colorBgContainer`. E.g: modal, pop-up, menu, etc.	string
		colorBgElevated: '#101020',
		// This color is used for the background color of the overall layout of the page. This token will only be used when it is necessary to be at the B1 visual level in the page. Other usages are wrong.	string
		colorBgLayout: '#080814',
		// The background color of the mask, used to cover the content below the mask, Modal, Drawer and other components use this token	string
		colorBgMask: 'rgba(0, 0, 0, 0.45)',
		// This color is used to draw the user's strong attention to the background color, and is currently only used in the background color of Tooltip.	string
		colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',
		// Default border color, used to separate different elements, such as: form separator, card separator, etc.	string	#
		colorBorder: '#A5A6B4',
		// Slightly lighter than the default border color, this color is the same as `colorSplit`. Solid color is used.	string	#
		colorBorderSecondary: '#f05e39',
		// The active state of the error color.	string	#
		// colorErrorActive: "#d9363e",
		// The background color of the error state.	string	#
		// colorErrorBg: "#fff2f0",
		// The active state background color of the error state.	string	#
		// colorErrorBgActive: "#ffccc7",
		// The hover state background color of the error state.	string	#
		// colorErrorBgHover: "#fff1f0",
		// The border color of the error state.	string
		// colorErrorBorder: "#ffccc7",
		// The hover state border color of the error state.	string
		// colorErrorBorderHover: "#ffa39e",
		// The hover state of the error color.	string
		// colorErrorHover: "#ff7875",
		// The default state of the text in the error color.	string
		// colorErrorText: "#ff4d4f",
		// The active state of the text in the error color.	string	#
		// colorErrorTextActive: "#d9363e",
		// The hover state of the text in the error color.	string	#
		// colorErrorTextHover: "#ff7875",
		// The darkest fill color is used to distinguish between the second and third level of fill color, and is currently only used in the hover effect of Slider.	string
		// colorFill: "rgba(0, 0, 0, 0.15)",
		// The weakest level of fill color is suitable for color blocks that are not easy to attract attention, such as zebra stripes, color blocks that distinguish boundaries, etc.	string
		// colorFillQuaternary: "rgba(0, 0, 0, 0.02)",
		// The second level of fill color can outline the shape of the element more clearly, such as Rate, Skeleton, etc. It can also be used as the Hover state of the third level of fill color, such as Table, etc.	string
		// colorFillSecondary: "rgba(0, 0, 0, 0.06)",
		// The third level of fill color is used to outline the shape of the element, such as Slider, Segmented, etc. If there is no emphasis requirement, it is recommended to use the third level of fill color as the default fill color.	string
		// colorFillTertiary: "rgba(0, 0, 0, 0.04)",
		// Active state of dark color of information color.	string	#
		// colorInfoActive: "#0958d9",
		// Light background color of information color.	string	#
		// colorInfoBg: "#e6f4ff",
		// Hover state of light background color of information color.	string	#
		// colorInfoBgHover: "#bae0ff",
		// Border color of information color.	string	#
		colorInfoBorder: '#f05e39',
		// Hover state of border color of information color.	string	#
		colorInfoBorderHover: '#f05e39',
		// Hover state of dark color of information color.	string
		// colorInfoHover:"#69b1ff",
		// Default state of text color of information color.	string
		// colorInfoText:"#1677ff",
		// Active state of text color of information color.	string
		// colorInfoTextActive:"#0958d9",
		// Hover state of text color of information color.	string
		// colorInfoTextHover:"#4096ff",
		// Control the color of hyperlink when clicked.	string
		// colorLinkActive:"#0958d9",
		// Control the color of hyperlink when hovering.	string
		// colorLinkHover:"#69b1ff",
		// Dark active state under the main color gradient.	string
		// colorPrimaryActive:"#0958d9",
		// Light background color of primary color, usually used for weak visual level selection state.	string
		// colorPrimaryBg:"#e6f4ff",
		// The hover state color corresponding to the light background color of the primary color.	string
		// colorPrimaryBgHover:"#bae0ff",
		// The stroke color under the main color gradient, used on the stroke of components such as Slider.	string
		colorPrimaryBorder: '#f05e39',
		// The hover state of the stroke color under the main color gradient, which will be used when the stroke Hover of components such as Slider and Button.	string
		colorPrimaryBorderHover: '#f05e39',
		// Hover state under the main color gradient.	string
		// colorPrimaryHover:"#4096ff",
		// Text color under the main color gradient.	string
		// colorPrimaryText:"#1677ff",
		// Active state of text color under the main color gradient.	string
		// colorPrimaryTextActive:"#0958d9",
		// Hover state of text color under the main color gradient.	string
		// colorPrimaryTextHover:"#4096ff",
		// Active state color of dark success color	string
		// colorSuccessActive:"#389e0d",
		// Light background color of success color, used for Tag and Alert success state background color	string
		// colorSuccessBg:"#f6ffed",
		// Light background color of success color, but antd does not use this token currently	string
		// colorSuccessBgHover:"#d9f7be",
		// Border color of success color, used for Tag and Alert success state border color	string
		colorSuccessBorder: '#f05e39',
		// Hover state color of success color border	string
		colorSuccessBorderHover: '#f05e39',
		// Hover state color of dark success color	string
		// colorSuccessHover:"#95de64",
		// Default state color of success color text	string
		// colorSuccessText:"#52c41a",
		// Active state color of success color text	string
		// colorSuccessTextActive:"#389e0d",
		// Hover state color of success color text	string
		// colorSuccessTextHover:"#73d13d",
		// Default text color which comply with W3C standards, and this color is also the darkest neutral color.	string
		colorText: '#A5A6B4',
		// The second level of text color is generally used in scenarios where text color is not emphasized, such as label text, menu text selection state, etc.	string
		colorTextSecondary: '#f05e39',
		// The third level of text color is generally used for descriptive text, such as form supplementary explanation text, list descriptive text, etc.	string
		colorTextTertiary: '#f05e39',
		// The fourth level of text color is the lightest text color, such as form input prompt text, disabled color text, etc.	string
		colorTextQuaternary: '#A5A6B4',
		// The active state of the warning color.	string
		// colorWarningActive:"#d48806",
		// The background color of the warning state.	string
		// colorWarningBg:"#fffbe6",
		// The hover state background color of the warning state.	string
		// colorWarningBgHover:"#fff1b8",
		// The border color of the warning state.	string
		// colorWarningBorder:"#ffe58f",
		// The hover state border color of the warning state.	string
		// colorWarningBorderHover:"#ffd666",
		// The hover state of the warning color.	string
		// colorWarningHover:"#ffd666",
		// The default state of the text in the warning color.	string
		// colorWarningText:"#faad14",
		// The active state of the text in the warning color.	string
		// colorWarningTextActive:"#d48806",
		// The hover state of the text in the warning color.	string
		// colorWarningTextHover:"#ffc53d",
		// Pure white color don't changed by theme	string
		// colorWhite:"#fff",
		// LG component height	number
		// controlHeightLG:40,
		// SM component height	number
		// controlHeightSM:24,
		// XS component height	number
		// controlHeightXS:16,
		// Font size of h1 tag.	number
		// fontSizeHeading1:38,
		// Font size of h2 tag.	number
		// fontSizeHeading2:30,
		// Font size of h3 tag.	number
		// fontSizeHeading3:24,
		// Font size of h4 tag.	number
		// fontSizeHeading4:20,
		// Font size of h5 tag.	number
		// fontSizeHeading5:16,
		// Large font size	number
		// fontSizeLG:16,
		// Small font size	number
		// fontSizeSM:12,
		// Super large font size	number
		// fontSizeXL:20,
		// Line height of text.	number
		// lineHeight:1.5714285714285714,
		// Line height of h1 tag.	number
		// lineHeightHeading1:1.2105263157894737,
		// Line height of h2 tag.	number
		// lineHeightHeading2:1.2666666666666666,
		// Line height of h3 tag.	number
		// lineHeightHeading3:1.3333333333333333,
		// Line height of h4 tag.	number
		// lineHeightHeading4:1.4,
		// Line height of h5 tag.	number
		// lineHeightHeading5:1.5,
		// Line height of large text.	number
		// lineHeightLG:1.5,
		// Line height of small text.	number
		// lineHeightSM:1.6666666666666667,
		// The default line width of the outline class components, such as Button, Input, Select, etc.	number
		// lineWidthBold:2,
		// Motion speed, fast speed. Used for small element animation interaction.	string
		// motionDurationFast: "0.1s",
		// Motion speed, medium speed. Used for medium element animation interaction.	string
		// motionDurationMid: "0.2s",
		// Motion speed, slow speed. Used for large element animation interaction.	string
		// motionDurationSlow: "0.3s",
		// number
		// size:16,
		// number
		// sizeLG:24,
		// number
		// sizeMD:20,
		// number
		// sizeMS:16,
		// number
		// sizeSM:12,
		// number
		// sizeXL:32,
		// number
		// sizeXS:8,
		// number
		// sizeXXL:48,
		// number
		// sizeXXS:4,
		controlItemBgActive: '#f05e39',
	},
	components: {
		Select: {
			optionSelectedColor: 'white',
		},
		Modal: {
			contentBg: '#080814',
		},
	},
};
